import { createAsyncThunk } from '@reduxjs/toolkit';
import { updateLastActiveEngagementId } from './user-summary-slice';

export const UpdateLastActiveEngagement = createAsyncThunk(
    'userSummary/updateLastActiveEngagement',
    async (engagementId: number, { dispatch, getState }: any) => {
        const axios = getState().core.axios;
        const response = await axios.put(`/api/Users/lastActiveEngagement/${engagementId}`);
        if (response?.status === 200) {
            dispatch(updateLastActiveEngagementId(engagementId));
        }
    }
);
